'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import {
//   createTaskProcessor,
//   updateTaskProcessor,
// } from "../../query";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactApollo = require('react-apollo');

var _Task = require('../Task');

var _Task2 = _interopRequireDefault(_Task);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // const NewTask = graphql(createTaskProcessor)(Task);


var TasksList = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(TasksList, _PrismaCmsComponent);

  function TasksList() {
    _classCallCheck(this, TasksList);

    return _possibleConstructorReturn(this, _PrismaCmsComponent.apply(this, arguments));
  } // static contextTypes = {
  //   ...PrismaCmsComponent.contextTypes,
  //   ProjectLink: PropTypes.func.isRequired,
  // }
  // constructor(props) {
  //   super(props);
  //   this.initProcessors();
  // }


  TasksList.prototype.componentWillMount = function componentWillMount() {
    this.initProcessors();
    _PrismaCmsComponent.prototype.componentWillMount && _PrismaCmsComponent.prototype.componentWillMount.call(this);
  };

  TasksList.prototype.initProcessors = function initProcessors() {
    var TaskView = this.props.TaskView;
    var _context$query = this.context.query,
        createTaskProcessor = _context$query.createTaskProcessor,
        updateTaskProcessor = _context$query.updateTaskProcessor;
    var UpdateTask = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(updateTaskProcessor))(TaskView);
    var CreateTask = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(createTaskProcessor))(TaskView);
    Object.assign(this.state, {
      UpdateTask: UpdateTask,
      CreateTask: CreateTask
    });
  };

  TasksList.prototype.renderItems = function renderItems() {
    var _this2 = this;

    var tasks = this.props.tasks;

    if (!tasks) {
      return null;
    }

    return tasks.map(function (n) {
      return _this2.renderItem(n);
    });
  };

  TasksList.prototype.renderItem = function renderItem(task, props) {
    // console.log("renderItem", task, props);
    var showDetails = this.props.showDetails;
    var _state = this.state,
        CreateTask = _state.CreateTask,
        UpdateTask = _state.UpdateTask;
    var id = task.id;
    var Renderer = void 0;

    if (id) {
      Renderer = UpdateTask;
    } else {
      Renderer = CreateTask;
    }

    return _react2.default.createElement(Renderer, _extends({
      key: id,
      data: {
        object: task
      },
      showDetails: showDetails
    }, props));
  };

  TasksList.prototype.render = function render() {
    return _PrismaCmsComponent.prototype.render.call(this, this.renderItems());
  };

  return TasksList;
}(_component2.default), _class.propTypes = _extends({}, _component2.default.propTypes, {
  tasks: _propTypes2.default.array.isRequired,
  showDetails: _propTypes2.default.bool.isRequired,
  TaskView: _propTypes2.default.func.isRequired
}), _class.defaultProps = _extends({}, _component2.default.defaultProps, {
  showDetails: false,
  // createTaskProcessorQuery: createTaskProcessor,
  // updateTaskProcessorQuery: updateTaskProcessor,
  TaskView: _Task2.default
}), _temp);
exports.default = TasksList;
module.exports = exports['default'];